export const PageNotFound = () => {
  return <div className="h1">PageNotFound</div>;
};

export default PageNotFound;
